import React from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import QuotaAlert from '../Settings/QuotaAlert';
import StatusBannerWrapper from '../Settings/StatusBannerWrapper';
import { useOrganizationStatus } from '../../hooks/useOrganizationStatus';

interface DashboardLayoutProps {
  children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  const { organization, loading } = useOrganizationStatus();

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Sidebar */}
      <Sidebar />

      {/* Contenu principal */}
      <div className="flex-1 flex flex-col">
        <Header />

        {/* Bannières de statut (Messages C, D, E) - conforme aux specs UX */}
        <div className="px-6 pt-4">
          <StatusBannerWrapper />
        </div>

        {/* Alertes de quota normales (80%, 90%) - seulement si ACTIVE */}
        {!loading && organization && organization.status === 'ACTIVE' && (
          <QuotaAlert position="top" dismissible minSeverity="medium" />
        )}

        <main className="p-6 overflow-y-auto flex-1">
          {children}
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
